<template>
    <el-card class="box-card">
        <el-tabs v-model="transferBindingActiveName" @tab-click="tabClickChange">
            <el-tab-pane name="fourth" label="待转绑信息">
                <div class="component-content">
                    <section class="content">
                        <el-card>
                            <el-form :inline="true" label-suffix=":">
                                <el-form-item>
                                    <el-select v-model="submitStatus" placeholder='请选择'>
                                        <el-option v-for="item in submitStatusOptions" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button  type="primary" @click="listByFinishValidate">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>

                        <el-table :data="validateData" border style="margin:20px 0;width: 100%">
                            <el-table-column prop="id" label="岸腾sid"></el-table-column>
                            <el-table-column prop="leitingPhone" label="雷霆电话号码"></el-table-column>
                            <el-table-column prop="submitStatus" label="验证进度">
                                <template slot-scope="scope">
                                    <span v-for="item in submitStatusOptions" v-if="item.value == scope.row.submitStatus">{{item.label}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="submitTime" label="时间">
                                <template slot-scope="scope">
                                    <span>{{Utils.formatDate(scope.row.submitTime)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="times" label="验证次数"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button class="player-btn" type="success" v-if="scope.row.submitStatus == 1" @click="toFirstTab(scope.row)">跳转查询</el-button>
                                    <el-button class="player-btn" type="success" v-if="scope.row.submitStatus == 1 || scope.row.submitStatus == -1 " @click="cancelBind(scope.row.id)">取消绑定</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </section>
                </div>
            </el-tab-pane>

            <el-tab-pane name="first" label="账号查询">
                <div class="component-content">
                    <section class="content">
                        <el-card>
                            <el-form :inline="true" label-suffix=":">
                                <el-form-item label='岸腾SID'>
                                    <el-input v-model="accountForm.sid" placeholder=''></el-input>
                                </el-form-item>
                            </el-form>
                            <el-form :inline="true">
                                <el-form-item>
                                    <el-button  type="primary" @click="getRecordByQuickSid">账号转绑记录</el-button>
                                </el-form-item>
                                <el-form-item v-if="bindingStep!==1">
                                    <el-button  type="primary" @click="findBySID">查询账号</el-button>
                                </el-form-item>
                                <el-form-item v-if="bindingStep == 3">
                                    <el-button  type="primary" @click="openMsgRecordByQuickSid">雷霆账号验证开关</el-button>
                                </el-form-item>
                                <el-form-item v-if="isOpened">
                                    <el-button  type="primary" @click="showMsgRecord">刷新验证记录</el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>

                        <el-card v-if="autoRecord">
                            <el-descriptions title="账号自动转绑记录(已有换绑记录，不能操作了)" border :column="4">
                                <el-descriptions-item label="绑定的账号/手机号">{{autoRecord.accountQuick}}</el-descriptions-item>
                                <el-descriptions-item label="操作时间">{{autoRecord.bindingTime}}</el-descriptions-item>
                                <el-descriptions-item label="岸腾sid">{{autoRecord.emailQuick}}</el-descriptions-item>
                                <el-descriptions-item label="绑定的雷霆sid">{{autoRecord.id}}</el-descriptions-item>
                            </el-descriptions>
                        </el-card>
                        <el-card v-if="manualRecord">
                            <el-descriptions title="账号手动转绑记录(已有换绑记录，不能操作了)" border :column="4">
                                <el-descriptions-item label="id">{{manualRecord.id}}</el-descriptions-item>
                                <el-descriptions-item label="leitingPhone">{{manualRecord.leitingPhone}}</el-descriptions-item>
                                <el-descriptions-item label="leitingSid">{{manualRecord.leitingSid}}</el-descriptions-item>
                                <el-descriptions-item label="submitDate">{{manualRecord.submitDate}}</el-descriptions-item>
                                <el-descriptions-item label="transTime">{{manualRecord.transTime}}</el-descriptions-item>
                                <el-descriptions-item label="transTag">{{manualRecord.transTag}}</el-descriptions-item>
                                <el-descriptions-item label="memo">{{manualRecord.memo}}</el-descriptions-item>
                                <el-descriptions-item label="record">{{manualRecord.record}}</el-descriptions-item>
                            </el-descriptions>
                        </el-card>
                        <el-card  v-if="autoRecord == null && manualRecord == null">
                            <div>无换绑记录，是否查询账号信息</div>
                        </el-card>

                        <template v-if="bindingStep!==1">
                            <el-table :data="players2" border style="margin:20px 0;width: 100%"
                                      @current-change="handlePlayerDataChange" highlight-current-row>
                                <el-table-column prop="id" label="用户id" width="120"></el-table-column>
                                <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                                <el-table-column prop="email" label="sid" width="120"></el-table-column>
                                <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                                <el-table-column prop="nick" label="昵称" width="120"></el-table-column>
                                <el-table-column prop="level" label="等级" width="50"></el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button class="player-btn" type="success" @click="showUserDetail(scope.row)">查看详细数据</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>

                        <el-card>
                            <el-form :inline="true" label-suffix=":">
                                <el-form-item label='雷霆账号（手机号）'>
                                    <el-input v-model="leitingAccountForm.tel" placeholder=''></el-input>
                                </el-form-item>
                            </el-form>
                            <el-form :inline="true">
                                <el-form-item>
                                    <el-button  type="primary" @click="getRecordByLeitingSid">账号换绑记录</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button  type="primary" @click="findTransferByTel">查询账号</el-button>
                                </el-form-item>

                            </el-form>
                        </el-card>
                        <el-card v-if="autoRecord2">
                            <el-descriptions title="账号自动转绑记录(已有换绑记录，不能操作了)" border :column="4">
                                <el-descriptions-item label="绑定的账号/手机号">{{autoRecord2.accountQuick}}</el-descriptions-item>
                                <el-descriptions-item label="操作时间">{{autoRecord2.bindingTime}}</el-descriptions-item>
                                <el-descriptions-item label="岸腾sid">{{autoRecord2.emailQuick}}</el-descriptions-item>
                                <el-descriptions-item label="绑定的雷霆sid">{{autoRecord2.id}}</el-descriptions-item>
                            </el-descriptions>
                        </el-card>
                        <el-card v-if="manualRecord2">
                            <el-descriptions title="账号手动转绑记录(已有换绑记录，不能操作了)" border :column="4">
                                <el-descriptions-item label="id">{{manualRecord2.id}}</el-descriptions-item>
                                <el-descriptions-item label="leitingPhone">{{manualRecord2.leitingPhone}}</el-descriptions-item>
                                <el-descriptions-item label="leitingSid">{{manualRecord2.leitingSid}}</el-descriptions-item>
                                <el-descriptions-item label="submitDate">{{manualRecord2.submitDate}}</el-descriptions-item>
                                <el-descriptions-item label="transTime">{{manualRecord2.transTime}}</el-descriptions-item>
                                <el-descriptions-item label="transTag">{{manualRecord2.transTag}}</el-descriptions-item>
                                <el-descriptions-item label="memo">{{manualRecord2.memo}}</el-descriptions-item>
                                <el-descriptions-item label="record">{{manualRecord2.record}}</el-descriptions-item>
                            </el-descriptions>
                        </el-card>
                        <el-card  v-if="autoRecord2 == null && manualRecord2 == null">
                            <div>无换绑记录，是否查询账号信息</div>
                        </el-card>

                        <el-table :data="players" border style="margin:20px 0;width: 100%"
                                  @current-change="handlePlayerDataChange" highlight-current-row>
                            <el-table-column prop="id" label="用户id" width="120"></el-table-column>
                            <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                            <el-table-column prop="email" label="sid" width="120"></el-table-column>
                            <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                            <el-table-column prop="nick" label="昵称" width="120"></el-table-column>
                            <el-table-column prop="level" label="等级" width="50"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button class="player-btn" type="success" @click="showUserDetail(scope.row)">查看详细数据</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <template>
                            <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                                <el-table-column type="expand">
                                    <template slot-scope="scope">
                                        <el-descriptions title="" :column="1" size="medium" border>
                                            <el-descriptions-item label="充值回调信息">
                                                <div>{{scope.row.chargeCallback}}</div>
                                            </el-descriptions-item>
                                            <el-descriptions-item label="游戏端响应消息">
                                                <div>{{scope.row.ntResult}}</div>
                                            </el-descriptions-item>
                                        </el-descriptions>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="gameOrderNo" label='订单号'>
                                </el-table-column>
                                <el-table-column prop="email" label='sid'>
                                </el-table-column>
                                <el-table-column prop="userId" label='玩家id'>
                                </el-table-column>
                                <el-table-column prop="server" label='服务器id'>
                                </el-table-column>
                                <el-table-column prop="channel" label='渠道'>
                                </el-table-column>
                                <el-table-column prop="publisher" label='渠道标志'>
                                </el-table-column>
                                <el-table-column prop="identifier" label='内购项'>
                                    <template slot-scope="scope">
                                        <div v-for="item in payOptions" v-if="item.id == scope.row.identifier">
                                            {{item.id}}({{$t(item.name)}})
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="unifiedIp" label='下单IP'>
                                </el-table-column>
                                <el-table-column label='下单时间'>
                                    <template slot-scope="scope">
                                        {{Utils.formatDate(scope.row.gmtCreate)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="thirdNo" label='第三方订单号'>
                                </el-table-column>
                                <el-table-column prop="notifyAmount" label='返回的金额'>
                                </el-table-column>
                                <el-table-column prop="chargeAmount" label='发起时的配置金额(单位：分)'>
                                </el-table-column>
                                <el-table-column prop="finalReward" label='最终奖励'>
                                </el-table-column>
                                <el-table-column prop="payStatus" label='订单状态'>
                                    <template slot-scope="scope">
                                        <div v-for="item in dealTagOptions" v-if="item.value == scope.row.payStatus">
                                            <el-tag type="success">{{item.label}}</el-tag>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="duplicateTag" label='重复付款标识'>
                                </el-table-column>
                                <el-table-column label='订单操作'>
                                    <template slot-scope="scope">
                                        <el-button v-if="scope.row.payStatus == 0" @click="repushOrder(scope.row)">重推订单</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagination">
                                <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                                               layout="total, prev, pager, next, jumper" :total="totalRow">
                                </el-pagination>
                            </div>
                        </template>

                        <el-dialog title="刷新验证记录" :visible.sync="msgRecordShow" width="50%" lock-scroll center>
                            <div>
                                <el-form :inline="true">
                                    <el-form-item>
                                        <el-button type="primary" @click="getMsgRecordByQuickSid">刷新</el-button>
                                    </el-form-item>
                                </el-form>

                                <el-descriptions title="验证记录" border :column="4">
                                    <el-descriptions-item label="submitStatus">
                                        <span v-if="submitData.submitStatus == -1">等待验证</span>
                                        <span v-if="submitData.submitStatus == 0">发起验证</span>
                                        <span v-if="submitData.submitStatus == 1">验证成功</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="leitingPhone">{{submitData.leitingPhone}}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </el-dialog>
                    </section>
                </div>
            </el-tab-pane>

            <el-tab-pane name="second" label="转绑">
                <el-card>
                    <el-descriptions title="账号信息" border :column="3">
                        <el-descriptions-item label="岸腾SID">{{accountForm.sid}}</el-descriptions-item>
                        <el-descriptions-item label="雷霆账号">{{leitingAccountForm.tel}}</el-descriptions-item>
                        <el-descriptions-item label="雷霆SID">{{submitTransferLeitingSid}}</el-descriptions-item>
                    </el-descriptions>
                </el-card>

                <el-table :data="playersAll" border style="margin:20px 0;width: 100%" highlight-current-row>
                    <el-table-column prop="id" label="用户id" width="120"></el-table-column>
                    <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                    <el-table-column prop="email" label="sid" width="120"></el-table-column>
                    <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                    <el-table-column prop="nick" label="昵称" width="120"></el-table-column>
                    <el-table-column prop="level" label="等级" width="50"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button class="player-btn" type="success" @click="showUserDetail(scope.row)">查看详细数据</el-button>
                            <el-checkbox v-model="scope.row.isSelected">取消绑定</el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>

                <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入备注"
                    v-model="submitTransferForm.memo">
                </el-input>

                <div style="margin-top: 20px;text-align: center;">
                    <el-button  type="success" @click="confirmBinding">确认绑定</el-button>
                </div>

                <el-dialog title="确认绑定" :visible.sync="transferBindingShow" width="50%" lock-scroll center>
                    <div>绑定列表：</div>
                    <el-table :data="playersAllConfirm" border style="margin:20px 0;width: 100%" highlight-current-row>
                        <el-table-column prop="id" label="用户id" width="120"></el-table-column>
                        <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                        <el-table-column prop="email" label="sid" width="120"></el-table-column>
                        <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                        <el-table-column prop="nick" label="昵称" width="120"></el-table-column>
                        <el-table-column prop="level" label="等级" width="50"></el-table-column>
                    </el-table>
                    <div>取消绑定:</div>
                    <el-table :data="playersAllCancel" border style="margin:20px 0;width: 100%" highlight-current-row :cell-style="cellBgStyle">
                        <el-table-column prop="id" label="用户id" width="120"></el-table-column>
                        <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                        <el-table-column prop="email" label="sid" width="120"></el-table-column>
                        <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                        <el-table-column prop="nick" label="昵称" width="120"></el-table-column>
                        <el-table-column prop="level" label="等级" width="50"></el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="transferBindingShow = false">取消</el-button>
                        <el-button type="primary" @click="submitTransfer">确认</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>

            <el-tab-pane name="third" label="转绑进度查询">
                <div class="component-content">
                    <section class="content">
                        <el-card>
                            <el-form :inline="true" label-suffix=":">
                                <el-form-item>
                                    <el-button  type="primary" @click="getAllProgress">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>

                        <el-table :data="allProgressData" border style="margin:20px 0;width: 100%">
                            <el-table-column prop="id" label="用户id" width="120"></el-table-column>
                            <el-table-column prop="leitingPhone" label="雷霆电话号码" width="120"></el-table-column>
                            <el-table-column prop="leitingSid" label="雷霆Sid" width="120"></el-table-column>
                            <el-table-column prop="memo" label="备注" width="120"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button class="player-btn" type="success" @click="getProgress(scope.row.id)">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-dialog title="详情" :visible.sync="progressShow" width="50%" lock-scroll center>
                            <el-table :data="progressDetailData" border>
                                <el-table-column prop="emailQuick" label="岸腾Sid" width="120"></el-table-column>
                                <el-table-column prop="id" label="编号" width="120"></el-table-column>
                                <el-table-column prop="leitingSid" label="雷霆Sid" width="120"></el-table-column>
                                <el-table-column prop="transResult" label="转绑结果" width="120"></el-table-column>
                                <el-table-column prop="transTag" label="transTag" width="120"></el-table-column>
                                <el-table-column prop="transTime" label="转绑时间" width="120"></el-table-column>
                            </el-table>
                        </el-dialog>
                    </section>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title='"id:"+player.user.id +"-昵称:"+player.user.nick + "的数据"' :visible.sync="previewDateShow" width="75%"
                   lock-scroll center>
            <el-tabs tab-position="left" style="height: 100%;" @tab-click="handleClick" v-model="activeName">
                <el-tab-pane name="basic" label="基础数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>基础信息</span>
                        </div>
                        <el-form label-position="left" :inline="true" label-suffix=":" size="mini" class="player-form">
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="id">
                                        {{player.user.id}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="昵称">
                                        {{player.user.nick}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="sid">
                                        {{player.user.email}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="探索者等级">
                                        {{player.user.level}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="回响等级">
                                        {{player.user.resoundLevel}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="当前战力">
                                        {{player.user.currentBattleE}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="连续登录次数">
                                        {{player.user.loginInARow}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="最近登录时间">
                                        {{player.user.loginModified}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="充值金额(Android)">
                                        {{player.user.charged}}
                                        <span class="charged-points">{{player.user.charged>0?'(分)':''}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="充值金额(iOS)">
                                        {{player.user.chargedIos}}
                                        <span class="charged-points">{{player.user.chargedIos>0?'(分)':''}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="总消费(不含代金券)">
                                        {{player.user.chargedTotal}}
                                        <span class="charged-points">{{player.user.chargedTotal>0?'(分)':''}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="总消费(含代金券)">
                                        {{player.user.chargedTotalAll}}
                                        <span class="charged-points">{{player.user.chargedTotalAll>0?'(分)':''}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="禁言/伪禁言状态(截止时间)">
                                        <span v-if="player.user.silence == 0">正常</span>
                                        <span v-if="player.user.silence == 1">{{(player.user.silenceEnd == -1)?'永久禁言':((player.user.silenceEnd < new Date().getTime())?'正常':'禁言(' + Utils.formatDate(new Date(player.user.silenceEnd)) + ')')}}</span>
                                        <span v-if="player.user.silence == 2">{{(player.user.silenceEnd == -1)?'永久禁言':((player.user.silenceEnd < new Date().getTime())?'正常':'伪禁言(' + Utils.formatDate(new Date(player.user.silenceEnd)) + ')')}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="封停状态(截止时间)">
                                        <span v-if="player.user.block == 0">正常</span>
                                        <span v-if="player.user.block == 1">{{(player.user.blockEnd == -1)?'永久封停':((player.user.blockEnd < new Date().getTime())?'正常':'后台封禁(' + Utils.formatDate(new Date(player.user.blockEnd)) + ')')}}</span>
                                        <span v-if="player.user.block == 2">{{(player.user.blockEnd == -1)?'永久封停':((player.user.blockEnd < new Date().getTime())?'正常':'系统封禁(' + Utils.formatDate(new Date(player.user.blockEnd)) + ')')}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                    <!--<el-card>-->
                    <!--<div slot="header" class="clearfix">-->
                    <!--<span>操作</span>-->
                    <!--</div>-->
                    <!--<div class="data-btn-group">-->
                    <!--<el-button type="primary">解除封停</el-button>-->
                    <!--<el-button type="primary">封停账号</el-button>-->
                    <!--</div>-->
                    <!--<div class="data-btn-group">-->
                    <!--<el-button type="primary">解除禁言-->
                    <!--<el-tooltip class="item" effect="dark" placement="top-start">-->
                    <!--<div slot="content">-->
                    <!--（包含解除禁言和伪禁言）-->
                    <!--</div>-->
                    <!--<i class="el-icon-info"></i>-->
                    <!--</el-tooltip>-->
                    <!--</el-button>-->
                    <!--<el-button type="primary">角色禁言</el-button>-->
                    <!--<el-button type="primary">角色伪禁言-->
                    <!--<el-tooltip class="item" effect="dark" placement="top-start">-->
                    <!--<div slot="content">-->
                    <!--（玩家发言内容仅自己可见，不会推送给别人）-->
                    <!--</div>-->
                    <!--<i class="el-icon-info"></i>-->
                    <!--</el-tooltip>-->
                    <!--</el-button>-->
                    <!--</div>-->
                    <!--<div class="data-btn-group">-->
                    <!--<el-button type="primary">修改角色名</el-button>-->
                    <!--</div>-->
                    <!--</el-card>-->

                    <!--历史记录-->
                    <!-- 神灵 -->
                    <!-- 神灵契约 -->
                    <!-- 好友 -->
                    <!-- 好友请求 -->
                    <!-- 社交好友 -->
                    <!-- 强敌 -->
                </el-tab-pane>
                <el-tab-pane name="monsters" label="怪兽数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <div style="margin-bottom: 10px;">怪兽查询</div>
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div>
                                    {{monsterQueryForm.identifier?('怪兽编号:'+ monsterQueryForm.identifier):''}}
                                    {{monsterQueryForm.lv2?('等级范围:'+ monsterQueryForm.lv1 + '-' + monsterQueryForm.lv2):''}}
                                    {{dateTime?('等级范围:'+ dateTime[0] + '至' + dateTime[1]):''}}
                                </div>
                                <div>
                                    <el-select v-model="monsterConditions" filterable clearable default-first-option
                                               :placeholder='$t("reward_editor.2")' @change="findMonsterByConditions">
                                        <el-option v-for="(item,index) in selectedMonsterConditionData" :key="index" :label="(item.identifier?'编号:':'') + item.identifier +' ' + (item.lv2?'等级:':'') + item.lv1 + '-' + item.lv2 + ' ' + (item.dateTime2?'时间:':'') + item.dateTime1 + (item.dateTime2?'-':'') + item.dateTime2"
                                                   :value="index">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-form label-suffix=":">
                            <el-form-item label="怪兽编号">
                                <el-select v-model="monsterQueryForm.identifier" filterable clearable default-first-option
                                           :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="item in monsterConfigs" :key="item.id" :label="item.id +'-' + $t(item.name)"
                                               :value="item.id">
                                        <el-image style="width: 30px; height: 30px; float: left" :src="'./static/monster_icon/'+item.id+'.png'"
                                                  fit="cover"></el-image>
                                        <span style="float: right">{{ $t(item.name) }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="等级范围">
                                <el-input-number v-model="monsterQueryForm.lv1" :min="1" :max="999" placeholder="最小等级"></el-input-number>
                                至
                                <el-input-number v-model="monsterQueryForm.lv2" :min="1" :max="999" placeholder="最小等级"></el-input-number>
                            </el-form-item>
                            <el-form-item label="获得时间">
                                <el-date-picker v-model="dateTime" type="daterange" range-separator='至'
                                                start-placeholder='起始时间' end-placeholder='结束时间' value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary" @click="selectMonsters">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="selectMonsterData" border  style="margin-top:20px;width: 100%">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand ">
                                    <el-card>
                                        <div slot="header" class="clearfix">
                                            <span>基础数据</span>
                                        </div>
                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="昵称:">
                                                    {{props.row.nick}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="是否可用:">
                                                    {{props.row.enabled?'可用':'禁用'}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="是否锁定:">
                                                    {{props.row.locked?'锁定':'无锁'}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                    <el-card>
                                        <div slot="header" class="clearfix">
                                            <span>养成数据</span>
                                        </div>
                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="穿着的皮肤:">
                                                    {{props.row.skinId}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="领域副本-已解锁最高难度:">
                                                    {{props.row.realmType}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="技能星级:">
                                                    {{props.row.abilityStar}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="性格id:">
                                                    {{props.row.temperamentId}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="性格点数:">
                                                    {{props.row.temperamentPoint}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="性格各项数据最高战绩:">
                                                    {{props.row.temperamentBest}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="强化次数:">
                                                    {{props.row.strengthenCount}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="强化数据:">
                                                    {{props.row.strengthen}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                    <el-card>
                                        <div slot="header" class="clearfix">
                                            <span>极化数据</span>
                                        </div>
                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="极化攻击力:">
                                                    {{props.row.plrzAtk}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="极化体力:">
                                                    {{props.row.plrzCon}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="极化霸气:">
                                                    {{props.row.plrzHaki}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="极化速度:">
                                                    {{props.row.plrzMspd}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="极化能力数据:">
                                                    {{props.row.plrzAbilities}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="极化重组临时数据:">
                                                    {{props.row.plrzTemp}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column prop="id" label="id"></el-table-column>
                        <el-table-column prop="identifier" label="编号" sortable></el-table-column>
                        <el-table-column label="怪兽名称">
                            <template slot-scope="scope">
                                <span v-for="item in monsterConfigs" :key="item.id" v-if="item.id == scope.row.identifier">
                                    {{ $t(item.name) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="怪兽图标">
                            <template slot-scope="scope">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/monster_icon/'+scope.row.identifier+'.png'"
                                          fit="cover">

                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="battleE" label="战力" sortable></el-table-column>
                        <el-table-column prop="level" label="等级" sortable></el-table-column>
                        <el-table-column prop="evolutionCount" label="进化次数" sortable></el-table-column>
                        <el-table-column prop="gmtCreate" label="获得时间" :formatter="formatterTime"></el-table-column>
                    </el-table>

                </el-tab-pane>
                <el-tab-pane name="skins" label="皮肤数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>怪兽皮肤</span>
                        </div>
                        <el-form label-suffix=":" label-position="left">
                            <el-form-item label="怪兽编号">
                                <el-select v-model="skinQueryForm.identifier" filterable default-first-option
                                           :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="item in monsterConfigs" :key="item.id" :label="item.id +'-' + $t(item.name)"
                                               :value="item.id">
                                        <el-image style="width: 30px; height: 30px; float: left" :src="'./static/monster_icon/'+item.id+'.png'"
                                                  fit="cover"></el-image>
                                        <span style="float: right">{{ $t(item.name) }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="皮肤类型">
                                <el-select v-model="skinQueryForm.type">
                                    <el-option :key="index" v-for="(sgt,index) in skinType" :label="sgt.val" :value="sgt.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary">查询</el-button>
                                <el-button type="success">补偿皮肤</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="player.skin" border  style="margin-top:20px;width: 100%">
                        <el-table-column prop="id" label="皮肤编号"></el-table-column>
                        <el-table-column prop="identifier" label="怪兽编号"></el-table-column>
                        <el-table-column prop="isTimeLimit" label="是否限时皮肤"></el-table-column>
                        <el-table-column prop="timeLimit" label="到期时间"></el-table-column>
                        <el-table-column label="操作">
                            <template>
                                <el-button type="danger">禁用</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane name="emblems" label="元核数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <div style="margin-bottom: 10px;">元核数据</div>
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div>
                                    {{emblemQueryForm.quality?('元核品质:'+ emblemQueryForm.quality):''}}
                                    {{emblemQueryForm.lv2?('等级范围:'+ emblemQueryForm.lv1 + '-' + emblemQueryForm.lv2):''}}
                                </div>
                                <div>
                                    <el-select v-model="emblemConditions" filterable clearable default-first-option
                                               :placeholder='$t("reward_editor.2")' @change="findEmblemByConditions">
                                        <el-option v-for="(item,index) in selectedEmblemConditionData" :key="index" :label="(item.quality?'品质:':'') + item.quality +' ' + (item.lv2?'等级:':'') + item.lv1 + '-' + item.lv2"
                                                   :value="index">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-form label-suffix=":" label-position="left">
                            <el-form-item label="品质">
                                <el-select v-model="emblemQueryForm.quality" filterable clearable default-first-option :placeholder='$t("reward_editor.2")'
                                           value="">
                                    <el-option v-for="item in emblemQuality" :key="item.id" :label="item.val" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="等级范围">
                                <el-input-number v-model="emblemQueryForm.lv1" :min="1" :max="100" ></el-input-number>
                                <el-input-number v-model="emblemQueryForm.lv2" :min="1" :max="100" ></el-input-number>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary" @click="selectEmblems">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="selectEmblemData" border  style="margin-top:20px;width: 100%">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-table :data="props.row.properties">
                                        <el-table-column prop="id" label="id"></el-table-column>
                                        <el-table-column  label="类型">
                                            <template slot-scope="prop">
                                                <span v-if="prop.row.type==0">
                                                    主属性
                                                </span>
                                                <span v-if="prop.row.type==1">
                                                    两字词条
                                                </span>
                                                <span v-if="prop.row.type==2">
                                                    四字词条
                                                </span>
                                                <span v-if="prop.row.type==3">
                                                    宿命
                                                </span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column label="属性效果">
                                            <template slot-scope="scope">
                                                {{$t(emblemEffectConfigMap[scope.row.effectId].name)}}
                                            </template>

                                        </el-table-column>
                                        <el-table-column label="品质">
                                            <template slot-scope="scope">
                                                {{emblemQualityMap[scope.row.quality]}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="rdFloat" label="随机浮动系数"></el-table-column>
                                    </el-table>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column prop="id" label="id"></el-table-column>
                        <el-table-column label="名称">
                            <template slot-scope="scope">
                                <span v-for="item in scope.row.properties" :key="item.id" v-if="item.type == 3">
                                     {{$t(emblemEffectConfigMap[item.effectId].name)}}-
                                </span>
                                <span v-for="item in scope.row.properties" :key="item.id" v-if="item.type == 0">
                                     {{$t(emblemEffectConfigMap[item.effectId].name)}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="图标">
                            <template slot-scope="scope">
                                <el-image v-if="scope.row.baseType > 0" style="width: 60px; height: 60px"
                                          :src="'./static/glyph_icon/'+scope.row.quality+'_'+scope.row.baseType+'.png'"
                                          fit="cover">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column  label="品质">
                            <template slot-scope="scope">
                                {{emblemQualityMap[scope.row.quality]}}
                            </template>
                        </el-table-column>
                        <el-table-column label="等级(阶段)">
                            <template slot-scope="scope">
                                {{scope.row.level}}（{{scope.row.stage}}）
                            </template>
                        </el-table-column>
                        <el-table-column prop="synchronizeLevel" label="同调等级"></el-table-column>

                        <el-table-column label="是否已鉴定">
                            <template slot-scope="scope">
                                <span v-if="scope.row.identified==true">
                                    已鉴定
                                </span>
                                <span v-if="scope.row.identified==false">
                                    未鉴定
                                </span>
                            </template>

                        </el-table-column>

                        <!--<el-table-column label="操作">-->
                        <!--<template>-->
                        <!--<el-button type="danger">禁用</el-button>-->
                        <!--</template>-->
                        <!--</el-table-column>-->
                    </el-table>
                </el-tab-pane>
                <!--<el-tab-pane name="lineups" label="阵容数据">-->
                <!--<el-card>-->
                <!--<div slot="header" class="clearfix">-->
                <!--<span>阵容数据</span>-->
                <!--</div>-->
                <!--<el-form label-suffix=":" label-position="left">-->
                <!--<el-form-item label="阵容编号">-->
                <!--<el-select v-model="lineupNo" filterable default-first-option-->
                <!--placeholder='选择阵容编号'>-->
                <!--<el-option v-for="item in lineupNoType" :key="item.id" :label="item.id +'-' + item.val"-->
                <!--:value="item.id">-->
                <!--</el-option>-->
                <!--</el-select>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="">-->
                <!--<el-button type="primary" @click="selectLineups">查询</el-button>-->
                <!--</el-form-item>-->
                <!--</el-form>-->
                <!--</el-card>-->

                <!--<el-table :data="lineups">-->
                <!--<el-table-column prop="lineupNo" label="阵容编号"></el-table-column>-->
                <!--<el-table-column prop="battleE" label="战力"></el-table-column>-->

                <!--</el-table>-->
                <!--</el-tab-pane>-->
                <el-tab-pane name="warGroove" label="战纹数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <div style="margin-bottom: 10px;">战纹数据</div>
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div>
                                    {{warGrooveQueryForm.quality?('战纹品质:'+ warGrooveQualityMap[warGrooveQueryForm.quality]):''}}
                                </div>
                                <div>
                                    <el-select v-model="warGrooveConditions" filterable clearable default-first-option
                                               :placeholder='$t("reward_editor.2")' @change="findWarGrooveByConditions">
                                        <el-option v-for="(item,index) in selectedWarGrooveConditionData" :key="index" :label="(item.quality!==''?'品质:':'') + warGrooveQualityMap[item.quality]"
                                                   :value="index">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-form label-suffix=":" label-position="left">
                            <el-form-item label="品质">
                                <el-select v-model="warGrooveQueryForm.quality" filterable default-first-option
                                           :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="item in warGrooveQuality" :key="item.id" :label="item.val"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary" @click="selectWarGroove">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="selectWarGrooveData">
                        <el-table-column prop="id" label="id"></el-table-column>
                        <el-table-column prop="identifier" label="编号"></el-table-column>
                        <el-table-column label="图标">
                            <template slot-scope="scope">
                                <span>{{$t('warGrooveConfigName_' + scope.row.identifier)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="quality" label="品质">
                            <template slot-scope="scope">
                                {{warGrooveQualityMap[scope.row.quality]}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pipeline" label="通道"></el-table-column>
                        <el-table-column prop="fillFlag" label="镶嵌标记"></el-table-column>
                    </el-table>

                </el-tab-pane>
                <el-tab-pane name="props" label="物品数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <div style="margin-bottom: 10px;">物品数据</div>
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div>
                                    {{propQueryForm.identifier?('物品编号:'+ propQueryForm.identifier):''}}
                                    {{propQueryForm.type?('物品大类:'+ propOptionMap[propQueryForm.type]):''}}
                                </div>
                                <div>
                                    <el-select v-model="propConditions" filterable clearable default-first-option
                                               :placeholder='$t("reward_editor.2")' @change="findPropByConditions">
                                        <el-option v-for="(item,index) in selectedPropConditionData" :key="index" :label="(item.identifier!==''?'物品编号:':'') + item.identifier + ' ' + (item.type!==''?'物品大类:':'') + propOptionMap[item.type]"
                                                   :value="index">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-form label-suffix=":" label-position="left">
                            <el-form-item label="物品编号">
                                <el-select v-model="propQueryForm.identifier" filterable clearable default-first-option
                                           :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="item in allPropData" :key="item.id" :label="item.id +'-' + item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="物品大类">
                                <el-select v-model="propQueryForm.type" filterable clearable default-first-option
                                           :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="(key,value) in propOptionMap" :key="key" :label="key"
                                               :value="value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary" @click="selectProp">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="selectPropData">
                        <el-table-column prop="identifier" label="编号"></el-table-column>
                        <el-table-column label="名称">
                            <template slot-scope="scope">
                                <span v-for="item in propConfigs" :key="item.id" v-if="item.id == scope.row.identifier">
                                    {{$t(item.name)}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="图标">
                            <template slot-scope="scope">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/item_icon/'+scope.row.identifier+'.png'"
                                          fit="cover">
                                    <div slot="error" class="image-slot">
                                        <el-image style="width: 60px; height: 60px"
                                                  :src="'./static/item_icon/0.png'"
                                                  fit="cover">
                                        </el-image>
                                    </div>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="大类">
                            <template slot-scope="scope">
                                {{propOptionMap[scope.row.type]}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="amount" label="数量"></el-table-column>
                        <el-table-column prop="buyTimes" label="购买次数"></el-table-column>
                        <el-table-column prop="gmtModified" label="上次修改时间"></el-table-column>
                        <el-table-column prop="lastRecoveryModified" label="最近一次回复时间"></el-table-column>
                    </el-table>

                </el-tab-pane>
                <el-tab-pane name="mainCity" label="建筑数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>建筑数据</span>
                        </div>
                        <!--<el-form label-suffix=":" label-position="left">-->

                        <!--<el-form-item label="">-->
                        <!--<el-button type="primary">查询</el-button>-->
                        <!--</el-form-item>-->
                        <!--</el-form>-->
                    </el-card>

                    <el-table :data="mainCitys">
                        <el-table-column prop="id" label="id" width="60px"></el-table-column>
                        <el-table-column label="建筑名">
                            <template slot-scope="scope">
                                <span v-for="item in mainCityOptions" v-if="item.id == scope.row.id">{{item.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="图标">
                            <template slot-scope="scope">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/main_city_icon/'+scope.row.id+'.png'"
                                          fit="cover">
                                    <div slot="error" class="image-slot">
                                        <el-image style="width: 60px; height: 60px"
                                                  :src="'./static/item_icon/0.png'"
                                                  fit="cover">
                                        </el-image>
                                    </div>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" label="等级"></el-table-column>
                        <el-table-column prop="finishTime" label="升级的完成时间"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </el-card>
</template>

<script>
import paginationController from '../../mixins/pagination'
import actionConfirm from '../../mixins/action_confirm'
import {
    mapState
} from 'vuex';
import gameApi from '../../service/game_api'
import commonApi from '../../service/common_api';
import componentQuery from '../../components/component_query'
import confApi from '../../service/conf_api'
import skin_type from '../../data/config/skin_type.json';
import emblem_quality from '../../data/config/emblem_quality.json';
import lineup_no_json from '../../data/config/lineup_no.json';
import war_groove_quality from '../../data/config/war_groove_quality'
import Utils from '../../lib/utils'

export default {
    name: "transfer_binding",
    data () {
        return {
            Utils: Utils,
            leitingAccountForm: {
                tel: ''
            },
            accountForm: {
                sid: ''
            },
            transferBindingActiveName: 'first',
            activeName: 'first',

            userResultInfo:[],
            playerQueryMode: ['mode_long_id','mode_short_id','mode_nick','mode_email'],
            players: [],
            players2: [],
            playersAll: [],
            payOptions: [],
            dateTime: '',
            iapFindBO: {
                uri: '',
                uid: '',
                dealTag: '-2',
                configId: 0,
                stime: '',
                etime: ''
            },
            dealTagOptions: [
                {
                    value: '-2',
                    label: '全部状态'
                },
                {
                    value: '-1',
                    label: '订单预创建'
                },
                {
                    value: '0',
                    label: '已下单'
                },
                {
                    value: '2',
                    label: '已发货'
                },
                {
                    value: '3',
                    label: '玩家退款'
                }
            ],
            transferBindingShow: false,
            transferBindingForm: {

            },

            previewDateShow: false,
            monsterConfigs: [],
            propConfigs:[],
            emblemEffectConfigs:[],
            emblemEffectConfigMap:{},
            godConfigs:[],
            warGrooveConfigs:[],
            skinConfigs:[],

            player: {
                user: {
                    id: -1,
                },
            },
            monsterQueryForm: {
                identifier: "",
                lv1: 1,
                lv2: 90,
            },
            skinQueryForm:{
                type:"",
                identifier: "",
            },
            emblemQueryForm:{
                quality:"",
                lv1: 1,
                lv2: 90,
                syncLv:"",
                stage:""
            },
            warGrooveQueryForm : {
                quality: ''
            },
            propQueryForm: {
                identifier: "",
                type: '0'
            },

            monsters:[],
            selectMonsterData:[],
            selectedMonsterConditionData:[],
            monsterConditions: '',

            emblems:[],
            selectEmblemData:[],
            selectedEmblemConditionData:[],
            emblemConditions: '',


            lineups:[],
            lineupNo:1,

            warGrooves:[],
            selectWarGrooveData:[],
            selectedWarGrooveConditionData:[],
            warGrooveConditions: '',

            props:[],
            selectPropData: [],
            selectedPropConditionData: [],
            propConditions: [],

            mainCitys:[],

            monsterShow: {},
            lineupNoType:lineup_no_json,
            skinType:skin_type,
            emblemQuality:emblem_quality,
            warGrooveQuality: war_groove_quality,
            emblemQualityMap:{},
            warGrooveQualityMap:{},

            propOptionMap:{
                '0':this.$t("reward_editor.39"),
                '1':this.$t("reward_editor.40"),
                '2':this.$t("reward_editor.41"),
                '3':this.$t("reward_editor.42"),
                '4':this.$t("reward_editor.43"),
                '5':'约束性道具',
                '6':this.$t("reward_editor.44"),
                '7':'战纹',
                '8':this.$t("reward_editor.46"),
                '9':this.$t("reward_editor.47"),
                '10':'回复类道具',
                '11':'头像',
                '12':'头像框',
                '13':'宝箱',
                '14':'皮肤',
                '15':'时效类道具',
            },
            allPropData: [],
            mainCityOptions: [
                {
                    id: 1,
                    name: '领地'
                },
                {
                    id: 2,
                    name: '骨场'
                },
                {
                    id: 3,
                    name: '木场'
                },
                {
                    id: 4,
                    name: '鳞场'
                },
                {
                    id: 5,
                    name: '仓库'
                },
                {
                    id: 6,
                    name: '探索营地'
                },
                {
                    id: 7,
                    name: '起源基石'
                },
                {
                    id: 8,
                    name: '一发入魂商店'
                },
                {
                    id: 9,
                    name: '斗技场'
                },
                {
                    id: 10,
                    name: '黑暗森林'
                },
                {
                    id: 11,
                    name: '迷之巢穴'
                },
                {
                    id: 12,
                    name: '起源殿'
                },
                {
                    id: 13,
                    name: '战墙'
                },
                {
                    id: 14,
                    name: '学舌鸦'
                },
                {
                    id: 15,
                    name: '造物台'
                },
                {
                    id: 16,
                    name: '祭坛'
                },
                {
                    id: 17,
                    name: '永生之茧'
                },
                {
                    id: 18,
                    name: '凿星裂痕'
                },
                {
                    id: 19,
                    name: '部落营地'
                }
            ],

            optionValue: '0',
            count1: '',
            count2: '',
            countSwitch: false,
            rate: 0.1,
            value: '',
            emblemEntryConfigs: [],
            emblemLevel: 1,
            emblemStage: 0,
            emblemQualityReward: 1,
            emblemFate:0,
            emblemFateCustomizeTags:[],
            emblemFateCustomize:100,
            emblemMainProperty: 1,
            emblemFateProperty: 51,
            editEmblemEntries:[
                {
                    entry:[3, 0],
                    quality:0,
                    active:true
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
            ],

            playersAllConfirm: [],
            playersAllCancel: [],

            bindingStep: 1,
            // 岸腾转绑记录
            autoRecord: '',     //自动
            manualRecord: '',   //手动

            //验证开关
            isOpened: false,

            // 刷新验证记录
            msgRecordShow: false,
            // 验证记录数据
            submitData: {},
            // 雷霆换绑记录
            autoRecord2: '',
            manualRecord2: '',

            // 换绑
            submitTransferForm: {
                leitingPhone: '',
                emailQuick: '',
                leitingSid: '',
                memo: '',
                record: '',
                allIds: '',
                leftIds: ''
            },

            submitTransferLeitingSid: '',

            progressForm:{
                emailQuick:'',
                leitingSid: '',
                leitingPhone: ''
            },

            allProgressData: [],
            progressDetailData: [],
            progressShow: false,

            submitStatus: 1,
            submitStatusOptions: [
                {
                    label: '待验证(等待玩家验证)',
                    value: -1
                },
                {
                    label: '待处理(玩家验证完成可操作转绑)',
                    value: 1
                },
                {
                    label: '已完成',
                    value: 2
                }
            ],
            validateData: []
        }
    },
    mixins: [paginationController, actionConfirm],
    computed: {
        ...mapState({
            token: state => state.user.userInfo.loginToken,
            serverGameList: state => state.server.serverGameList,
            serverWorldList: state => state.server.serverWorldList
        }),
    },
    created() {
        this.getReadData();

        this.emblemQuality.forEach(item=>{
            this.emblemQualityMap[item.id] = item.val;
        })
        this.warGrooveQuality.forEach(item=>{
            this.warGrooveQualityMap[item.id] = item.val;
        })
    },
    mounted() {
        this.getConfigs();
    },
    methods: {
        tabClickChange(tab,event) {
            if (tab.name == 'second') {
                if (this.accountForm.sid && this.leitingAccountForm.tel) {
                    this.findBySID();
                    this.findTransferByTel();
                    setTimeout(() => {
                        this.playersAll = this.players.concat(this.players2)
                    },4000)
                }
            }
            this.dataHandled = [];
        },

        showUserDetail(player) {
            this.showUserDetailAxios(player);
            this.previewDateShow = true;
            this.activeName = 'basic';
        },
        /**
         * 查询用户详情
         */
        showUserDetailAxios(player) {
            let self = this;
            gameApi.playerDetail({
                playerQueryForm: {
                    uri: player.uri,
                    serverId: player.server,
                    userId: player.id,
                    email: '',
                    nick: ''
                },
                token: this.token
            }).then(res => {
                self.player = res.content.detail
                self.player.uri = player.uri;
                self.player.server = player.server;
                self.player.id = player.id;
                let time = self.player.user.loginModified;
                let newDate = new Date();
                if (time) {
                    newDate.setTime(time);
                    self.player.user.loginModified = newDate.toLocaleString();
                }

                time = self.player.user.buyEnergyModified
                if (time) {
                    newDate = new Date();
                    newDate.setTime(time);
                    self.player.user.buyEnergyModified = newDate.toLocaleString();
                }

                time = self.player.user.energyModified
                if (time) {
                    newDate = new Date();
                    newDate.setTime(time);
                    self.player.user.energyModified = newDate.toLocaleString();
                }
            })
        },

        getPlayerMonsters() {
            let self = this;
            gameApi.findMonstersByPlayerId({
                playerQueryForm: {
                    uri: self.player.uri,
                    serverId: self.player.server,
                    userId: self.player.id,
                    email: '',
                    nick: ''
                },
                token: this.token
            }).then(res => {
                self.monsters = res.content.monsters;
            })
        },

        getPlayerEmblems() {
            let self = this;
            gameApi.findEmblemsByPlayerId({
                playerQueryForm: {
                    uri: self.player.uri,
                    serverId: self.player.server,
                    userId: self.player.id,
                    email: '',
                    nick: ''
                },
                token: this.token
            }).then(res => {
                self.emblems = res.content.emblems;
                self.emblems.forEach(emblemItem =>{
                    emblemItem.properties.forEach(property=>{
                        if(property.type === 0){
                            emblemItem.baseType = property.effectId;
                        }
                    })
                })
                console.log(self.emblems);
            })
        },

        getPlayerLineups() {
            let self = this;
            gameApi.findLineupsByPlayerId({
                playerQueryForm: {
                    uri: self.player.uri,
                    serverId: self.player.server,
                    userId: self.player.id,
                    email: '',
                    nick: ''
                },
                token: this.token
            }).then(res => {
                self.lineups = res.content.lineups;
                console.log(self.lineups);
            })
        },

        getPlayerWarGroove() {
            let self = this;
            gameApi.findWarGroovesByPlayerId({
                playerQueryForm: {
                    uri: self.player.uri,
                    serverId: self.player.server,
                    userId: self.player.id,
                    email: '',
                    nick: ''
                },
                token: this.token
            }).then(res => {
                var warGrooves = [];
                res.content.warGrooves.forEach(item => {
                    var temp = item.id.split('_');
                    warGrooves.push({
                        id: item.id,
                        identifier: temp[1],
                        quality: temp[2],
                        pipeline: temp[0]
                    })
                })

                self.warGrooves = warGrooves;
                console.log(self.warGrooves);
            })
        },

        getPlayerProps() {
            let self = this;
            gameApi.findPropsByPlayerId({
                playerQueryForm: {
                    uri: self.player.uri,
                    serverId: self.player.server,
                    userId: self.player.id,
                    email: '',
                    nick: ''
                },
                token: this.token
            }).then(res => {
                self.props = res.content.props;
                console.log(self.props);
            })
        },

        getPlayerSkins() {
            let self = this;
            gameApi.findSkinsByPlayerId({
                playerQueryForm: {
                    uri: self.player.uri,
                    serverId: self.player.server,
                    userId: self.player.id,
                    email: '',
                    nick: ''
                },
                token: this.token
            }).then(res => {
            })
        },

        handleClick(tab, event) {
            let self = this;
            if(tab.name =='monsters'){
                // self.getPlayerMonsters();
                self.selectMonsters();
            }else if(tab.name =='emblems'){
                // self.getPlayerEmblems();
                self.selectEmblems();
            }else if(tab.name =='warGroove'){
                // self.getPlayerWarGroove();
                self.selectWarGroove();
            }else if(tab.name =='props'){
                // self.getPlayerProps();
                self.selectProp();
            }else if(tab.name =='skins'){
                self.getPlayerSkins();
            }else if(tab.name =='lineups'){
                self.getPlayerLineups();
            } else if(tab.name =='mainCity'){
                gameApi.findMainCityByPlayerId({
                    playerQueryForm: {
                        uri: self.player.uri,
                        serverId: self.player.server,
                        userId: self.player.id,
                        email: '',
                        nick: ''
                    },
                    token: this.token
                }).then(res => {
                    self.mainCitys = res.content.mainCitys;
                    console.log(self.mainCitys);
                })
            }

        },

        getConfigs() {
            let self = this;
            let tables = 'monster_config,monster_temperament_config,emblem_effect_config,' +
                'war_groove_config,skin_config,god_config,prop_config';
            commonApi.getConfs({
                tables: tables
            }).then(res => {
                self.monsterConfigs = res.monster_config;
                self.propConfigs = res.prop_config;
                self.emblemEffectConfigs = res.emblem_effect_config;
                self.emblemEffectConfigs.forEach(item=>{
                    self.emblemEffectConfigMap[item.id] = item;
                })

                self.godConfigs = res.god_config;
                self.warGrooveConfigs = res.war_groove_config;
                self.skinConfigs = res.skin_config;

                self.propConfigs.forEach(item => {
                    self.allPropData.push({
                        id: item.id,
                        name: self.$t(item.name)
                    })
                })

                self.monsterConfigs.forEach(item => {
                    self.allPropData.push({
                        id: item.id + 10000,
                        name: self.$t(item.name) + self.$t('reward_editor.4')
                    })

                    let monsterRace = item.race;
                    let monsterQuality = item.quality;
                    if (monsterQuality === 4 && monsterRace.indexOf("_") > -1) {
                        self.allPropData.push({
                            id: item.id + 20000,
                            name: self.$t(item.name) + self.$t('reward_editor.17')
                        });
                        self.allPropData.push({
                            id: item.id + 30000,
                            name: self.$t(item.name) + self.$t('reward_editor.18')
                        });

                        self.allPropData.push({
                            id: item.id + 70000,
                            name: self.$t(item.name) + "的进化光谱"
                        });

                        self.propConfigs.push({
                            id: item.id + 70000,
                            name: self.$t(item.name) + "的进化光谱",
                            big_type: 19
                        })
                    }
                })
            })

        },
        /**
         * 禁言
         */
        banTalk(id) {

        },
        /**
         * 封号
         */
        banAccount(id) {

        },

        formatterTime(row) {
            var gmtCreate = row.gmtCreate;
            gmtCreate = Utils.formatDate(gmtCreate);
            return gmtCreate;
        },

        // 筛选怪兽
        selectMonsters() {
            this.getPlayerMonsters();
            setTimeout(() => {
                var identifier = this.monsterQueryForm.identifier;
                var lv1 = this.monsterQueryForm.lv1;
                var lv2 = this.monsterQueryForm.lv2;
                var dateTime = this.dateTime;

                if (dateTime == null) {
                    dateTime = '';
                }
                var dateTime1 = dateTime!==''?new Date(dateTime[0]).getTime():'';
                var dateTime2 = dateTime!==''?new Date(dateTime[1]).getTime():'';
                var monsters = this.monsters;
                var _monsters = [];
                monsters.forEach(item => {
                    if (identifier !== '' && dateTime !== '') {
                        if ((item.identifier == identifier) && (item.level >= lv1 && item.level <= lv2) && (item.gmtCreate >= dateTime1 && item.gmtCreate <= dateTime2)) {
                            _monsters.push(item)
                        }
                    } else if (identifier !== '' && dateTime == '') {
                        if ((item.identifier == identifier) && (item.level >= lv1 && item.level <= lv2)) {
                            _monsters.push(item)
                        }
                    } else if (identifier == '' && dateTime !== '') {
                        if ((item.level >= lv1 && item.level <= lv2) && (item.gmtCreate >= dateTime1 && item.gmtCreate <= dateTime2)) {
                            _monsters.push(item)
                        }
                    } else if (identifier == '' && dateTime == '') {
                        if ((item.level >= lv1 && item.level <= lv2)) {
                            _monsters.push(item)
                        }
                    }

                })
                this.selectMonsterData = _monsters;

                if (this.selectMonsterData.length > 0) {
                    if (this.selectedMonsterConditionData.length >= 5) {
                        this.selectedMonsterConditionData.splice(0,1)
                    }
                    this.selectedMonsterConditionData.push({
                        identifier: identifier,
                        lv1: lv1,
                        lv2: lv2,
                        dateTime1: dateTime?dateTime[0]:'',
                        dateTime2: dateTime?dateTime[1]:''
                    })
                }
            },1000)
        },

        // 筛选元核-元核
        selectEmblems() {
            this.getPlayerEmblems();
            setTimeout(() => {
                var quality = this.emblemQueryForm.quality;
                var lv1 = this.emblemQueryForm.lv1;
                var lv2 = this.emblemQueryForm.lv2;
                var emblems = this.emblems;
                var _emblems = [];
                emblems.forEach(item => {
                    if (quality !== '') {
                        if ((quality == item.quality) && (item.level >= lv1 && item.level <= lv2)) {
                            _emblems.push(item)
                        }
                    } else {
                        if ((item.level >= lv1 && item.level <= lv2)) {
                            _emblems.push(item)
                        }
                    }
                })

                this.selectEmblemData = _emblems;

                if (this.selectEmblemData.length > 0) {
                    if (this.selectedEmblemConditionData.length >= 5) {
                        this.selectedEmblemConditionData.splice(0,1)
                    }
                    this.selectedEmblemConditionData.push({
                        quality: quality,
                        lv1: lv1,
                        lv2: lv2
                    })
                }
            },1000)
        },

        // 筛选阵容
        selectLineups() {
            this.getPlayerLineups();
            setTimeout(() => {
                var lineups = this.lineups;
                var lineupNo = this.lineupNo;
                var _lineups = [];
                lineups.forEach(item => {
                    if (lineupNo == item.lineupNo) {
                        _lineups.push(item)
                    }
                })
                this.lineups = _lineups;
            },1000)
        },

        // 筛选战纹
        selectWarGroove() {
            this.getPlayerWarGroove();
            setTimeout(() => {
                var quality = this.warGrooveQueryForm.quality;
                var warGrooves = this.warGrooves;
                var _warGrooves = [];
                warGrooves.forEach(item => {
                    if (quality == item.quality) {
                        _warGrooves.push(item)
                    }
                })

                this.selectWarGrooveData = _warGrooves;

                if (this.selectWarGrooveData.length > 0) {
                    if (this.selectedWarGrooveConditionData.length >= 5) {
                        this.selectedWarGrooveConditionData.splice(0,1)
                    }
                    this.selectedWarGrooveConditionData.push({
                        quality: quality
                    })
                }
            },1000)
        },

        // 筛选物品
        selectProp() {
            this.getPlayerProps();
            setTimeout(() => {
                var identifier = this.propQueryForm.identifier;
                var type = this.propQueryForm.type;
                var props = this.props;
                var _props = [];
                props.forEach(item => {
                    if (type !== '' && identifier !== '') {
                        if ((type == item.type) && (identifier == item.identifier)) {
                            _props.push(item)
                        }
                    } else if (identifier !== '' && type == '') {
                        if (identifier == item.identifier) {
                            _props.push(item)
                        }
                    } else if (type !== '' && identifier == '') {
                        if (type == item.type) {
                            _props.push(item)
                        }
                    }
                })

                this.selectPropData = _props;

                if (this.selectPropData.length > 0) {
                    if (this.selectedPropConditionData.length >= 5) {
                        this.selectedPropConditionData.splice(0,1)
                    }
                    this.selectedPropConditionData.push({
                        identifier: identifier,
                        type: type
                    })
                }
            },1000)
        },

        findMonsterByConditions(e) {
            this.dateTime == '';
            var data = this.selectedMonsterConditionData[e];

            this.monsterQueryForm.identifier = data.identifier;
            this.monsterQueryForm.lv1 = data.lv1;
            this.monsterQueryForm.lv2 = data.lv2;
            if (data.dateTime1 == '' || data.dateTime2 == '') {
                this.dateTime == '';
            } else {
                this.dateTime = [data.dateTime1,data.dateTime2];
            }

            this.selectMonsters();
        },

        findEmblemByConditions(e) {
            var data = this.selectedEmblemConditionData[e];

            this.emblemQueryForm.quality = data.quality;
            this.emblemQueryForm.lv1 = data.lv1;
            this.emblemQueryForm.lv2 = data.lv2;

            this.selectEmblems();
        },

        findWarGrooveByConditions(e) {
            var data = this.selectedWarGrooveConditionData[e];

            this.warGrooveQueryForm.quality = data.quality;

            this.selectWarGroove();
        },

        findPropByConditions(e) {
            var data = this.selectedPropConditionData[e];

            this.propQueryForm.identifier = data.identifier;
            this.propQueryForm.type = data.type;

            this.selectProp();
        },

        getReadData() {
            let self = this;
            confApi.getReadData({
                token: this.token,
                tableName: 'iap_buy_config'
            }).then(res => {
                self.payOptions.push({
                    id: 0,
                    name: '全部'
                })
                res.forEach(item => {
                    if (item.product_id !== '/') {
                        self.payOptions.push(item);
                    }
                })
            })
        },

        findTransferByTel() {
            var self = this;
            if (self.leitingAccountForm.tel == '') {
                this.$message({
                    type: 'error',
                    message: '手机号不能为空！！！'
                });
                return;
            }
            gameApi.findTransferByTel({
                findTransferByTelForm: {
                    tel: self.leitingAccountForm.tel
                },
                token: self.token
            }).then(res => {
                console.log('res',res);
                if (!res) {
                    this.$message({
                        type: 'warning',
                        message: '雷霆账号不存在'
                    });
                    return;
                }
                var email = res;
                self.submitTransferLeitingSid = email;
                self.players = [];
                self.serverGameList.forEach(item => {
                    let uri = item.inner_urls?item.inner_urls.split(';')[0]:item.inner_urls;
                    gameApi.findPlayersByTransfer({
                        findPlayersByTransferForm: {
                            uri: uri,
                            serverId: item.server_number,
                            userId: '',
                            email: email,
                            nick: ''
                        },
                        token: self.token
                    }).then(res => {
                        let resList = res.content.list;
                        resList.forEach(resItem => {
                            resItem.uri = uri;
                            self.serverWorldList.forEach(worldItem => {
                                if (item.world_id == worldItem.id) {
                                    resItem.worldUri = worldItem.inner_urls.split(';')[0];
                                }
                            })
                        })
                        let currentPlayerIds = [];
                        self.players.forEach(item => {
                            currentPlayerIds.push(item.id);
                        })

                        for (let i = 0; i < resList.length; i++) {
                            if (currentPlayerIds.indexOf(resList[i].id) > -1){
                                continue;
                            }else{
                                self.players = self.players.concat(resList[i]);
                            }
                        }
                    })
                })

            })
        },

        handlePlayerDataChange(currentRow) {
            if (currentRow !== undefined) {
                this.iapFindBO.uri = currentRow.uri;
                this.iapFindBO.uid = currentRow.id;
                this.findCharges();
            }
        },

        // 玩家充值查询
        findCharges() {
            this.iapFindBO.stime = this.dateTime[0];
            this.iapFindBO.etime = this.dateTime[1];
            if (this.iapFindBO.configId === '' || this.iapFindBO.dealTag === ''){
                this.$message({
                    type: 'error',
                    message: '内购项和订单状态不能为空！！！'
                });
                return;
            }

            gameApi.findCharges({
                token: this.token,
                iapFindBO: this.iapFindBO
            }).then(res => {
                res.content.iaps.forEach(item => {
                    if (item.finalReward !== '' && item.finalReward !== undefined) {
                        item.finalReward = item.finalReward + (item.finalReward?'(':'') + this.formatterRewardsToCN(item.finalReward) + (item.finalReward?')':'');
                    }
                })
                this.dataHandled = res.content.iaps;
                this.totalRow = res.content.iaps.length;
            })
        },

        formatterRewardsToCN(row) {
            var arr = row.split(',');
            var result = '';
            arr.forEach(item => {
                if (item !== '') {
                    this.resolveRewardStr(item);

                    // let optionValueCN = this.optionMap[this.optionValue];
                    let idCn = this.getIdCn(this.optionValue,this.value);
                    let finalCount = '';
                    if (this.countSwitch) {
                        finalCount = this.count1 + "-" + this.count2;
                    } else {
                        finalCount = this.count1
                    }
                    let finalContentCN = idCn + "_" + finalCount;
                    result = result + (result?',':'') + finalContentCN;
                }

            })
            return result;
        },
        resolveRewardStr(str){
            let self = this;

            if (str == '') {
                self.countSwitch = false;
                self.rateSwitch = false;
                self.isDetail = false;
                self.count1 = 1;
                self.count2 = 1;
                self.rate = 0.1;
                self.emblemLevel = 1;
                self.emblemStage = 0;
                self.emblemQualityReward = 1;
                self.emblemMainProperty = 1;
                self.emblemFate = 0;
                self.emblemFateCustomize = 100;
                self.emblemFateProperty = 51;

                self.editEmblemEntries = [
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ]
            }

            let rewardArray = str.toString().split("_");

            for (let index = 0; index < rewardArray.length; index++) {
                const element = rewardArray[index];
                switch (index) {
                    case 0:
                        // let bigTypeArry = element.split("$");
                        // //大类
                        // self.optionValue = bigTypeArry[0];
                        // //identify
                        // self.value = parseInt(bigTypeArry[1]);
                        self.value = element;

                        if (self.value == 50001) {
                            self.emblemRandomByQuality = false;
                        } else {
                            self.emblemRandomByQuality = true;
                        }
                        break;
                    case 1:
                        //数量
                        let countArry = element.split("-");
                        if(countArry.length>1){
                            self.countSwitch = true;
                            self.count1 = countArry[0];
                            let rateAndCount = countArry[1].split('|');
                            if (rateAndCount.length>1) {
                                self.rateSwitch = true;
                                self.count2 = rateAndCount[0];
                                self.rate = rateAndCount[1];
                            } else {
                                self.rateSwitch = false;
                                self.count2 = countArry[1];
                            }
                        }else{
                            self.countSwitch = false;

                            let rateAndCount = countArry[0].split('|');
                            if (rateAndCount.length>1) {
                                self.rateSwitch = true;
                                self.count1 = rateAndCount[0];
                                self.rate = rateAndCount[1];
                            } else {
                                self.rateSwitch = false;
                                self.count1 = countArry[0];
                            }
                        }
                        break;
                    case 2:
                        //等级
                        self.emblemLevel = parseInt(element);

                        if (self.optionValue == '7') {
                            self.warGrooveQuality = parseInt(element);
                        }
                        break;
                    case 3:
                        //阶段
                        self.emblemStage = parseInt(element);

                        if (self.optionValue == '7') {
                            if (element) {
                                self.warGrooveChannelSwitch = true;
                                self.warGrooveChannelUp = parseInt(element);
                            } else {
                                self.warGrooveChannelSwitch = false;
                            }
                        }
                        break;
                    case 4:
                        //品质
                        self.emblemQualityReward = parseInt(element);

                        if (self.optionValue == '7') {
                            self.warGrooveChannelDown = parseInt(element);
                        }
                        break;
                    case 5:
                        //宿命
                        let fateArray = element.split("#");
                        self.emblemFate = 3;
                        if(fateArray.length>1){
                            for (let i = 0; i < fateArray.length; i++) {
                                const element = fateArray[i];
                                let item = fateArray.splice("@");
                                self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                            }
                        }else{
                            if(element>0){
                                self.emblemFate = 2;
                                self.emblemFateProperty = parseInt(element);
                            }else{
                                self.emblemFate = 0;
                            }
                        }

                        if (self.optionValue == '7') {
                            self.warGrooveChannelLeft = parseInt(element);
                        }

                        break;
                    case 6:
                        //宿命自定义概率
                        self.emblemFateCustomize = parseInt(element*100);

                        if (self.optionValue == '7') {
                            self.warGrooveChannelRight = parseInt(element);
                        }
                        break;
                    case 7:
                        //主属性
                        self.emblemMainProperty = parseInt(element);
                        break;
                    case 8:
                        //词条属性
                        let entryArray = element.split("#");
                        for (let index = 0; index < entryArray.length; index++) {
                            const entryItem = entryArray[index];
                            let current = self.editEmblemEntries[index];

                            self.emblemEntryConfigs.forEach(item => {
                                item.children.forEach(iitem => {
                                    if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                        self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                        self.editEmblemEntries[index].active = true;
                                    } else {
                                        self.editEmblemEntries[index].active = false;
                                    }
                                })
                            })

                            self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                        }

                        let countAndEntry = entryArray[entryArray.length-1].split('|');
                        if (countAndEntry.length>1) {
                            self.rateSwitch = true;
                            self.rate = countAndEntry[1];
                        } else {
                            self.rateSwitch = false;
                        }
                        break;
                    default:
                        break;
                }
            }
        },

        getIdCn(optionValue,id){
            let self = this;
            if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" || optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15"){
                //道具
                return self.$t('propConfigName_'+id);
            }else if(optionValue == "1"){
                //怪兽
                return self.$t('monsterName_' + id);
            }else if(optionValue == "2"){
                //怪兽碎片
                return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
            }else if(optionValue == "6"){
                //怪兽觉醒水晶
                return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
            }else if(optionValue == "8"){
                //怪兽觉醒水晶碎片
                return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
            }else if(optionValue == "7"){
                //战纹
                return self.$t('warGrooveConfigName_' + id);
            }
        },

        findBySID() {
            var self = this;
            if (self.accountForm.sid == '') {
                this.$message({
                    type: 'error',
                    message: 'SID不能为空！！！'
                });
                return;
            }

            self.players2 = [];
            self.serverGameList.forEach(item => {
                let uri = item.inner_urls?item.inner_urls.split(';')[0]:item.inner_urls;
                gameApi.playerList({
                    playerQueryForm: {
                        uri: uri,
                        serverId: item.server_number,
                        userId: '',
                        email: self.accountForm.sid,
                        nick: ''
                    },
                    token: self.token
                }).then(res => {
                    let resList = res.content.list;
                    resList.forEach(resItem => {
                        resItem.uri = uri;
                        self.serverWorldList.forEach(worldItem => {
                            if (item.world_id == worldItem.id) {
                                resItem.worldUri = worldItem.inner_urls.split(';')[0];
                            }
                        })
                    })

                    let currentPlayerIds = [];
                    self.players2.forEach(item => {
                        currentPlayerIds.push(item.id);
                    })

                    for (let i = 0; i < resList.length; i++) {
                        if (currentPlayerIds.indexOf(resList[i].id) > -1){
                            continue;
                        }else{
                            self.players2 = self.players2.concat(resList[i]);
                        }
                    }

                    //self.players2 = self.players2.concat(res.content.list);

                    self.bindingStep = 3;
                })
            })
        },

        confirmBinding() {
            this.transferBindingShow = true;
            this.playersAllConfirm = [];
            this.playersAllCancel = [];

            this.playersAll.forEach(item => {
                if (!item.isSelected) {
                    this.playersAllConfirm.push(item);
                } else {
                    this.playersAllCancel.push(item)
                }
            })
        },

        cellBgStyle({row, column, rowIndex, columnIndex}) {
            if (row.isSelected) {
                return {
                    background: '#ebedf0'
                }
            }
        },

        // 查询岸腾sid的换绑记录
        getRecordByQuickSid() {
            var self = this;
            if (self.accountForm.sid == '') {
                this.$message({
                    type: 'error',
                    message: 'SID不能为空！！！'
                });
                return;
            }

            gameApi.getRecordByQuickSid({
                quickSid: self.accountForm.sid,
                token: self.token
            }).then(res => {
                self.autoRecord = res.autoRecord;
                self.manualRecord = res.manualRecord;
                self.bindingStep = 2;
            })
        },

        // 雷霆账号验证开关
        openMsgRecordByQuickSid() {
            var self = this;
            if (self.accountForm.sid == '') {
                this.$message({
                    type: 'error',
                    message: 'SID不能为空！！！'
                });
                return;
            }
            gameApi.openMsgRecordByQuickSid({
                quickSid: self.accountForm.sid,
                token: self.token
            }).then(res => {
                self.isOpened = true;
                self.submitData = res;
                self.$message({
                    type: 'success',
                    message: '已打开验证'
                })
            })
        },

        showMsgRecord() {
          this.msgRecordShow = true;
        },

        // 刷新验证记录
        getMsgRecordByQuickSid() {
            var self = this;
            gameApi.getMsgRecordByQuickSid({
                quickSid: self.accountForm.sid,
                token: self.token
            }).then(res => {
                self.submitData = res;
                self.leitingAccountForm.tel = res.leitingPhone;
            })
        },

        // 查询雷霆sid的换绑记录
        getRecordByLeitingSid() {
            var self = this;
            if (self.leitingAccountForm.tel == '') {
                this.$message({
                    type: 'error',
                    message: '手机号不能为空！！！'
                });
                return;
            }

            gameApi.findTransferByTel({
                findTransferByTelForm: {
                    tel: self.leitingAccountForm.tel
                },
                token: self.token
            }).then(email => {
                if (!email) {
                    this.$message({
                        type: 'warning',
                        message: '雷霆账号不存在'
                    });
                    return;
                }
                self.submitTransferLeitingSid = email;

                gameApi.getRecordByLeitingSid({
                    leitingSid: self.submitTransferLeitingSid,
                    token: self.token
                }).then(res => {
                    self.autoRecord2 = res.autoRecord;
                    self.manualRecord2 = res.manualRecord;
                })
            })
        },

        // 换绑
        submitTransfer() {
            var self = this;

            var record = [];
            self.playersAllConfirm.forEach(item => {
                record.push({
                    id: item.id,
                    server: item.server,
                    email: item.email,
                    channel: item.channel,
                    nick: item.nick,
                    level: item.level
                })
            })
            record = JSON.stringify(record);

            var allIds = [];
            self.playersAll.forEach(item=> {
                allIds.push(item.id)
            })

            var leftIds = [];
            self.playersAllCancel.forEach(item=> {
                leftIds.push(item.id)
            })
            allIds = allIds.join(',');
            leftIds = leftIds.join(',');


            self.submitTransferForm = {
                leitingPhone: self.leitingAccountForm.tel,
                emailQuick: self.accountForm.sid,
                leitingSid: self.submitTransferLeitingSid,
                memo: self.submitTransferForm.memo,
                record: record,
                allIds: allIds,
                leftIds: leftIds
            }

            gameApi.submitTransfer({
                submitTransferForm: self.submitTransferForm,
                token: self.token
            }).then(res => {
                self.transferBindingShow = false;
                self.$message({
                    type: 'success',
                    message: '换绑成功'
                })
                self.submitTransferForm = {
                    leitingPhone: '',
                    emailQuick: '',
                    leitingSid: '',
                    memo: '',
                    record: '',
                    allIds: '',
                    leftIds: ''
                }
                self.playersAll = [];
            })
        },

        // 换绑进度查询
        getAllProgress() {
            var self = this;
            gameApi.getAllProgress({
                token: self.token
            }).then(res => {
                self.allProgressData = res;
            })
        },

        // 换绑进度单个查询
        getProgress(id) {
            var self = this;
            self.progressShow = true;
            self.progressForm.emailQuick = id;
            gameApi.getProgress({
                token: self.token,
                progressForm: self.progressForm
            }).then(res => {
                self.progressDetailData = res.manualRecordDetails;
            })
        },

        // 待转绑信息查询
        listByFinishValidate() {
            var self = this;
            gameApi.listByFinishValidate({
                token: self.token,
                submitStatus: self.submitStatus
            }).then(res => {
                self.validateData = res;
            })
        },

        // 跳转查询
        toFirstTab(data) {
            var self = this;
            self.transferBindingActiveName = 'first';
            self.accountForm.sid = data.id;
            self.leitingAccountForm.tel = data.leitingPhone;
        },

        // 取消绑定
        cancelBind(id) {
            let self = this;
            self.$confirm("是否取消绑定", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                gameApi.cancelBind({
                    token: self.token,
                    quickSid: id
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: '取消成功'
                    })
                })
            })
        }

    },
    components: {
        componentQuery
    }
}
</script>

<style scoped>
    .charged-points {
        color: #99a9bf;
    }
</style>



// WEBPACK FOOTER //
// src/views/players/transfer_binding.vue